'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.addDays;


// WEBPACK FOOTER //
// ./~/sugar-date/date/addDays.js